function trimTrailingSlash(value) {
  return value ? value.replace(/\/+$/, '') : '';
}

function parsePositiveInt(value, fallback) {
  const parsedValue = Number.parseInt(value, 10);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallback;
}

function getCurrentOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return 'http://localhost:8000';
}

export const API_BASE_URL = trimTrailingSlash(
  process.env.VUE_APP_API_BASE_URL || getCurrentOrigin()
);

export const WS_BASE_URL = trimTrailingSlash(
  process.env.VUE_APP_WS_BASE_URL || API_BASE_URL.replace(/^http/i, 'ws')
);

export const TEACHER_POLL_INTERVAL_MS = parsePositiveInt(
  process.env.VUE_APP_TEACHER_POLL_INTERVAL_MS,
  3000
);

export const STUDENT_POLL_INTERVAL_MS = parsePositiveInt(
  process.env.VUE_APP_STUDENT_POLL_INTERVAL_MS,
  5000
);

export const TEACHER_STATUS_POLL_INTERVAL_MS = parsePositiveInt(
  process.env.VUE_APP_TEACHER_STATUS_POLL_INTERVAL_MS,
  TEACHER_POLL_INTERVAL_MS
);

export const TEACHER_DETAIL_POLL_INTERVAL_MS = parsePositiveInt(
  process.env.VUE_APP_TEACHER_DETAIL_POLL_INTERVAL_MS,
  Math.max(TEACHER_POLL_INTERVAL_MS, 5000)
);

export const STUDENT_STATUS_POLL_INTERVAL_MS = parsePositiveInt(
  process.env.VUE_APP_STUDENT_STATUS_POLL_INTERVAL_MS,
  STUDENT_POLL_INTERVAL_MS
);

export const STUDENT_DETAIL_POLL_INTERVAL_MS = parsePositiveInt(
  process.env.VUE_APP_STUDENT_DETAIL_POLL_INTERVAL_MS,
  Math.max(STUDENT_POLL_INTERVAL_MS, 7000)
);

export const POLL_INTERVAL_HIDDEN_MS = parsePositiveInt(
  process.env.VUE_APP_POLL_INTERVAL_HIDDEN_MS,
  15000
);
